import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { getScarcityFlag } from 'utils/store/getScarcityFlag';

import { UnitDescription } from 'components/unit/UnitDescription';
import { UnitPrice } from 'components/unit/UnitPrice';
import UnitListItem from 'components/unit/UnitList/UnitListItem';
import { Image } from 'components/core/Image';

import fivexfive from '/assets/images/unit-icons/new/5x5.svg';

import './unitDetails.scss';
import { getUnitImageUrl } from '../../../utils/units';

export function UnitDetails({
	className,
	amenitiesText,
	vehicleAccommodation,
	sizeText,
	unitTypeText,
	promotion,
	price,
	priceSize = 'medium',
	regularPrice,
	isScarce,
	unitQuantity,
	facility,
	unit,
	showIcon
}) {
	return (
		<UnitListItem className={className}>
			<div className="unit-details">
			{showIcon && (<Image
				src={getUnitImageUrl(unit.length, unit.width) || fivexfive}
				alt={sizeText}
				className="unit-size-icon"
				lazyLoad={false}
			/>)}
				<UnitDescription
					unitSize={sizeText}
					unitType={unitTypeText}
					promotion={promotion}
					amenitiesText={amenitiesText}
					vehicleAccommodation={vehicleAccommodation}
					giftCardOffer={facility?.giftCardOffer}
				/>

				<div className="price-column">
					<UnitPrice
						price={price}
						regularPrice={regularPrice}
						linkedPrice={false}
						size={priceSize}
						unitQuantity={unitQuantity}
						isScarce={isScarce}
						link={facility.url}
						showFees={facility.showFeeWarning}
						fees={facility.fees}
					/>
				</div>
			</div>
		</UnitListItem>
	);
}

UnitDetails.propTypes = {
	priceSize: PropTypes.string,
	promotion: PropTypes.string,
	sizeText: PropTypes.string,
	unitTypeText: PropTypes.string,
	price: PropTypes.string,
	className: PropTypes.string,
	regularPrice: PropTypes.string,
	amenitiesText: PropTypes.string,
	vehicleAccommodation: PropTypes.string,
	isScarce: PropTypes.bool,
	unitQuantity: PropTypes.number,
	facility: PropTypes.object,
	showIcon: PropTypes.bool,
	unit: PropTypes.object
};

const EnhancedUnitDetails = ({
	amenitiesText,
	unit,
	priceSize,
	className,
	facility,
	showIcon,
}) => {
	const mappedProps = {
		amenitiesText,
		priceSize,
		className,
		vehicleAccommodation: unit.vehicleAccommodation,
		promotion: unit.promotion,
		sizeText: unit.sizeText,
		unitTypeText: unit.unitTypeText,
		price: unit.price.text,
		regularPrice:
			get(unit, 'regularPrice.value') !== get(unit, 'price.value')
				? get(unit, 'regularPrice.text', null)
				: null,
		isScarce: getScarcityFlag([unit]),
		unitQuantity: unit.quantity,
		facility,
		unit,
		showIcon,
	};
	return <UnitDetails {...mappedProps} />;
};

export default React.memo(EnhancedUnitDetails);
